export const API_PATHS = {
  me: '/api/me',
  /** GET what deleting it would meet; DELETE to erase it. */
  account: '/api/account',
  home: '/api/home',
  act: '/api/act',
  ticket: '/api/ticket',
  broker: '/api/broker',
  fallbacks: '/api/fallbacks',
  notifications: '/api/notifications',
  telegram: '/api/telegram',
  invite: '/api/invite',
  invites: '/api/invites',
  join: '/api/join',
  addCheck: '/api/add/check',
  symbols: '/api/symbols',
  levels: '/api/levels',
  recommendation: '/api/recommendation',
  recommendationRead: '/api/recommendation/read',
  recommendationHistory: '/api/recommendation/history',
  rollover: '/api/rollover',
  exit: '/api/exit',
  /** The sessions before today on a position's tracked contract, which its exit ticket offers levels off. */
  sessions: '/api/sessions',
  recommendationRollover: '/api/recommendation/rollover',
  members: '/api/members',
  analysts: '/api/analysts',
  channelLog: '/api/channel/posts',
  /** Addressed by post, not digest: bytes are content-addressed, so a digest URL would be a shareable capability. */
  channelImage: '/api/channel/image',
  drafts: '/api/drafts',
  systems: '/api/systems',
  ontology: '/api/ontology',
  indications: '/api/indications',
  calendar: '/api/calendar',
  participants: '/api/participants',
  news: '/api/news',
  pnl: '/api/pnl',
  investments: '/api/investments',
} as const;
